import React, { Component } from 'react';
import Authentication, { UserClass } from '../module/Authentication';
import Common from '../module/Common';

import { Toaster, toast } from 'react-hot-toast';

import { RefreshData } from '../Service';
import { ApiService } from '../services/ApiService';
import { BroadcastService } from '../services/BroadcastService';
const ManagerContext = React.createContext();

const Recievers = [];
var Timer = null;

/**
 * TO DO: Consider using a service class like "GlobalStateService" instead of React's ContextManager to manage globally available data.
 */
export class ManagerProvider extends Component {

    apiService = new ApiService();
    broadcastService = new BroadcastService();
    
    state = {
        User: new UserClass(),
        Tick: 1,
        LastRefresh: Date.now(),
        SelectedClientCode: null,
        SelectedStateId: null
    };

    AsnLogin = (username, password) => {
        Authentication.AsnLogin(username, password)
            .then((data) => {
                this.setState({ 
                    User: data,
                    SelectedStateId: data.stateId,
                    SelectedClientCode: data.clientCode
                });
                this.broadcastService.notify('loginSuccess');
            }).catch((data) => {
                this.ToastErr("Login Failed");
            });
    }

    OscLogin = (oscToken) => {
        Authentication.OscLogin(oscToken)
            .then((data) => {
                this.setState({ 
                    User: data,
                    SelectedStateId: data.stateId,
                    SelectedClientCode: data.clientCode
                });
                this.broadcastService.notify('loginSuccess');
            })
    }

    ComoLogin = (comoToken) => {
        Authentication.ComoLogin(comoToken)
            .then((data) => {
                this.setState({
                    User: data,
                    SelectedStateId: data.stateId,
                    SelectedClientCode: data.clientCode
                });
                this.broadcastService.notify('loginSuccess');
            })
    }
    
    IsOscUser = () => {
        var ret = false

        if (this.state.User.oscToken?.length > 5) {
            ret = true;
        } 

        return ret;
    }

    IsAsnUser = () => {
        return Authentication.IsAsnUser();
    }

    LocalSessionCheck = () => {
        Authentication.CheckStoredSession();

        if (Authentication.IsLoggedIn()) {
            const user = Authentication.User;
            this.setState({ 
                User: user,
                SelectedStateId: user.stateId,
                SelectedClientCode: user.clientCode
            });
            this.broadcastService.notify('authSuccess');
        }
    }

    LogOut = () => {
        Authentication.LogOut(() => {
            // Clear cached data
            this.apiService.clearCachedData();
            
            // Redirect to bookings if the user was logged in from an external booking page, redirect him to that booking page when he logged out.
            if(this.state?.User?.clientBrand) {
                const bookingLink = Common.getBookingLink(this.state?.User?.stateId, this.state?.User?.oscToken);
                window.location.href = bookingLink;
            } else {
                this.setState({ User: new UserClass() });
                this.broadcastService.notify('logoutSuccess');
                clearInterval(Timer);
            }

        });
    }

    IsLoggedIn = () => {
        return Authentication.IsLoggedIn();
    }
    

    AllowedClients = () => {
        return Authentication.GetAllowedClients();
    }

    AllowedStates = () => {
        let vic, nsw, sa, wa, qld = 0;
        let states = [];

        let clients = Authentication.GetAllowedClients();

        clients.forEach(function (client) {
            switch (client.stateId)
            {
                case 1:
                    if (!vic) { states.push('VIC'); }
                    vic = 1;
                    break;
                case 2:
                    if (!nsw) { states.push('NSW'); }
                    nsw = 1;
                    break;
                case 3:
                    if (!qld ) { states.push('QLD'); }
                    qld = 1;
                    break;
                case 4:
                    if (!sa) { states.push('SA'); }
                    sa = 1;
                    break;
                case 5:
                    if (!wa) { states.push('WA'); }
                    wa = 1;
                    break;
                default:
                    break;
            }
        });

        return states;
    }

    ToastInf = (message) => {
        toast(message);
    }

    ToastErr = (message) => {
        toast.error(message);
    }

    componentDidMount() {
        /*
         * Signals:
         * 'Logout'
         * 'Login'
         * 'Refresh' */
        Recievers.push(RefreshData);

        this.setState({ User: new UserClass(), LastRefresh: Date.now() });
        this.LocalSessionCheck();
    }


    render() {
        const { User, LastRefresh, SelectedClientCode, SelectedStateId } = this.state;
        const { IsOscUser, IsAsnUser, AsnLogin, OscLogin, ComoLogin, LogOut, IsLoggedIn, AllowedClients, AllowedStates, ToastErr, ToastInf } = this;
        
        return (
            <ManagerContext.Provider value={{
                User,
                IsOscUser,
                IsAsnUser,
                IsLoggedIn,
                AsnLogin,
                OscLogin,
                ComoLogin,
                LogOut,
                LastRefresh,
                AllowedClients,
                AllowedStates,
                ToastErr,
                ToastInf,
                SelectedClientCode,
                SelectedStateId
            }}>
                {this.props.children}
            </ManagerContext.Provider>
        )
    }
}

export default ManagerContext;
